import { render, staticRenderFns } from "./authStatusResult.vue?vue&type=template&id=03f47352&scoped=true"
import script from "./authStatusResult.vue?vue&type=script&lang=js"
export * from "./authStatusResult.vue?vue&type=script&lang=js"
import style0 from "./authStatusResult.vue?vue&type=style&index=0&id=03f47352&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f47352",
  null
  
)

export default component.exports